import { useMutation, useQuery } from 'react-query';
import { getUserCompanies, setActiveCompany } from 'api/companies';
import { cookies } from 'static';
import { CropsAccountSelection, CropsCompany } from 'types';

const hasAuthToken = () => Boolean(localStorage.getItem(cookies.FarmersPlanToken));

export const useUserCompanies = () => {
  return useQuery<CropsCompany[]>(
    'crops-user-companies',
    getUserCompanies,
    {
      enabled: hasAuthToken(),
      staleTime: 60 * 1000,
      retry: 1,
    },
  );
};

export const useSetActiveCompany = () => {
  return useMutation(
    (accountId: number): Promise<CropsAccountSelection> =>
      setActiveCompany(accountId),
  );
};
